import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=majestic%20fantasy%20fairy%20forest%20with%20ancient%20sacred%20tree%2C%20floating%20magical%20light%20orbs%20and%20tiny%20winged%20fairies%2C%20stylized%20digital%20painting%2C%20deep%20emerald%20green%20and%20warm%20gold%20palette%2C%20soft%20glow%2C%20atmospheric%20and%20cinematic&width=1600&height=900&seq=hero-fairy-forest&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80" />
      </div>

      <div className="container-site relative w-full py-20 text-center">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200">
          <i className="ri-sparkling-2-fill" />
          韩国妖精漫画 · 奇幻魔法异世界精选
        </span>
        <h1 className="mx-auto max-w-3xl font-heading text-3xl font-bold leading-snug text-background-50 md:text-5xl md:leading-tight">
          妖精漫画堂，<br className="md:hidden" />
          带你闯入精灵与妖怪共存的奇幻世界
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          异世界穿越、精灵契约、妖怪神话，三大世界观设定全收录。点开即见高人气妖精漫画分类与故事简介，快速找到你想追的那部奇幻作品。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/category/otherworld" className="btn btn-accent w-full px-7 py-3 text-base sm:w-auto">
            浏览漫画分类
            <i className="ri-arrow-right-line" />
          </Link>
          <Link to="#ranking" className="btn w-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-base text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto">
            查看热门排行
          </Link>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-2.5">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="rounded-full border border-background-50/20 bg-foreground-950/30 px-4 py-1.5 text-xs text-background-100 backdrop-blur-sm transition-colors hover:border-accent-300 hover:text-accent-200"
            >
              {c.name}
            </Link>
          ))}
          <span className="rounded-full border border-background-50/20 bg-foreground-950/30 px-4 py-1.5 text-xs text-background-100 backdrop-blur-sm">
            每日更新速览
          </span>
        </div>
      </div>
    </section>
  );
}